import {Html5QrcodeScanner, Html5QrcodeScanType} from 'html5-qrcode'
import React, { useEffect, useState } from 'react';

const QrScanner = () => {
  const [qrOutput, setQrOutput] = useState<string | null>(null);

  const onScanSuccess = (qrCodeMessage: string) => {
    setQrOutput(qrCodeMessage)
  }
  
  useEffect(() => {
    let config = {
      fps: 10,
      qrbox: 250,
      rememberLastUsedCamera: false,
      supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA]
    };

    const html5QrcodeScanner = new Html5QrcodeScanner("reader", config, false);
    html5QrcodeScanner.render(onScanSuccess, () => {});

    return () => {
      html5QrcodeScanner.clear().catch((error: any) => {
        console.error("Failed to clear html5QrcodeScanner. ", error);
      });
    };
  }, [])
  
  return (
    <div style={{width: '400px', height: '300px'}}>
      <div>
        <div id="reader"></div>
      </div>
      <div>
        <h4>Scan Result </h4>
        <div id="result">
          {qrOutput || 'Result goes here'}
        </div>
      </div>

    </div>
  );
}

export default QrScanner